export default "__VITE_ASSET__Bxk6VgPu__"